module.exports = __webpack_public_path__ + "img/icon-question-rating-like-hover.7465fb11.svg";